import React from 'react';
import './WorldPath.css';

function WorldPath({ from, to, completed, unlocked }) {
    // Calculate the path
    const dx = to.x - from.x;
    const dy = to.y - from.y;
    const length = Math.sqrt(dx * dx + dy * dy);

    // Calculate control point for curved path
    const midX = (from.x + to.x) / 2;
    const midY = (from.y + to.y) / 2;

    // Add some curve to the path
    const perpX = -dy / length * 20;
    const perpY = dx / length * 20;
    const ctrlX = midX + perpX;
    const ctrlY = midY + perpY;

    // Create curved path
    const pathD = `M ${from.x} ${from.y} Q ${ctrlX} ${ctrlY} ${to.x} ${to.y}`;

    const pathClass = completed ? 'completed' : unlocked ? 'unlocked' : 'locked';

    return (
        <g className={`world-path ${pathClass}`}>
            {/* Background path (track) */}
            <path
                className="path-track"
                d={pathD}
                fill="none"
                strokeWidth="8"
                strokeLinecap="round"
            />

            {/* Foreground path (progress) */}
            <path
                className="path-progress"
                d={pathD}
                fill="none"
                strokeWidth="6"
                strokeLinecap="round"
                strokeDasharray={length}
                strokeDashoffset={completed ? 0 : length}
            />

            {/* Dotted path for locked */}
            {!unlocked && (
                <path
                    className="path-dots"
                    d={pathD}
                    fill="none"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeDasharray="8 12"
                />
            )}

            {/* Animated particles on unlocked paths */}
            {unlocked && !completed && (
                <circle className="path-particle" r="4">
                    <animateMotion
                        dur="2s"
                        repeatCount="indefinite"
                        path={pathD}
                    />
                </circle>
            )}
        </g>
    );
}

export default WorldPath;
